import { useSelector } from 'react-redux';
import type { RootState } from '~/redux/store';
import { useEffect } from 'react';

function identifyUser(user: { id: string; externalId?: string }) {
  const FS = (window as any).FS;
  if (!FS || !user?.id) {
    return;
  }

  FS('setIdentity', {
    uid: user.id,
    properties: {
      displayName: user.externalId,
      email: user.externalId,
    },
  });
}

export default function Dashboard() {
  const role = useSelector((state: RootState) => state.auth.user?.role);
  const user = useSelector((state: RootState) => state.auth.user);

  useEffect(() => {
    if (user?.id) {
      identifyUser({ id: user.id, externalId: user.externalId });
    }
  }, [user]);

  return (
    <div className="w-full bg-neut-bg min-h-[calc(100vh-70px)]">
      <title>Dashboard</title>
      <h1 className="text-3xl font-semibold capitalize w-full text-center flex  items-center justify-center  h-[calc(100vh-70px)]">
        Welcome {role?.toLowerCase()}
      </h1>
    </div>
  );
}
